var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
'app',
_vm.user.listPermissions(),
_vm.isPrint ? 'print' : ''
],attrs:{"id":"app"}},[_c('a',{staticClass:"skip-to-content-link",attrs:{"href":"#main"}},[_vm._v("Skip to content")]),_c('the-header'),_c('the-main',{attrs:{"id":"main"}}),_c('the-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }